import TermsIcon from "../../assets/icons/more.svg";

const Terms = () => {
  return (
    <div className="mt-10">
      <div className="flex items-center">
        <img src={TermsIcon} width={28} alt="شرایط استفاده" />
        <h1 className="font-bold mr-3">شرایط استفاده از خدمات بادی‌بان</h1>
      </div>

      <div className="my-10">
        <p className="text-justify leading-7">
          این متن توضیح مفصلی از شرایط استفاده از وب‌سایت و برنامه بادی‌بان به
          آدرس
          <a href="https://bodybon.info" className="text-pr_primary">
            <strong> www.bodybon.info </strong>
          </a>
          و کلیه خدمات ارائه‌شده از طریق آن را ارائه می‌دهد. استفاده از خدمات
          بادی‌بان، به معنی موافقت با این شرایط است. لطفا به منظور آشنایی با
          شرایط استفاده از پلتفرم بادی‌بان این سند را مطالعه کنید و چنانچه سوالی
          داشتید، خوشحال می‌شویم از طریق ایمیل
          <a href="mailto:support@bodybon.info" className="text-pr_primary">
            <strong> support@bodybon.info </strong>
          </a>
          با ما در تماس باشید.
        </p>

        <div>
          <h2 className="font-bold text-lg mb-2 mt-10">شرایط عمومی</h2>

          <p className="text-justify leading-7">
            محدودیت سنی: برای ثبت حساب کاربری و استفاده از خدمات پلتفرم
            بادی‌بان، باید حداقل ۱۸ سال داشته باشید. کاربران زیر ۱۸ سال می‌بایست
            با نظارت والدین یا قیم قانونی خود از خدمات استفاده کنند.
            <br /> نیازمندی‌های کاربری: برای دسترسی به خدمات بادی‌بان، شما به یک
            دستگاه متصل به اینترنت فعال و نرم‌افزاری سازگار نیاز دارید. این
            عوامل بر کیفیت استفاده شما از خدمات ما تأثیرگذار خواهند بود.
            <br /> هزینه‌ استفاده: استفاده از خدمات اولیه پلتفرم تفسیر آزمایش
            بادی‌بان دارای سقف معینی بوده و در دفعات اول برای تعداد محدودی
            درخواست رایگان است. سپس کاربران می‌بایست برای استفاده از سایر خدمات
            تخصصی‌تر پلتفرم که در آپدیت‌های بعدی در دسترس قرار خواهد گرفت و
            همچنین استفاده بیشتر از سقف درخواست تعیین‌شده نیز نیازمند پرداخت
            هزینه است.
            <br /> کاربران بین‌المللی: خدمات پلتفرم بادی‌بان از سرورهای داخل
            ایران ارائه می‌شوند. استفاده از آن در خارج از ایران نیز ممکن است؛
            اما بررسی مسائل حقوقی مربوطه در کشور محل اقامت برعهده کاربر است.
          </p>
        </div>

        <h2 className="font-bold text-lg mb-2 mt-10">خرید از بادی‌بان </h2>

        <p className="text-justify leading-7">
          پلتفرم تفسیر آزمایش بادی‌بان، از پروتکل‌های امنیتی برای انجام
          تراکنش‌ها استفاده می‌کند و تمامی اطلاعات پرداخت فقط در درگاه پرداخت
          معتبر زیبال ثبت می‌شوند. کاربران باید برای دریافت خدمات بادی‌بان، حساب
          کاربری ایجاد کنند و تمامی قوانین مرتبط با دریافت خدمات رایگان و
          غیررایگان را رعایت نمایند.
          <br /> تمامی شرایط دریافت خدمات اعم از رایگان و غیررایگان در پلتفرم
          بادی‌بان از قانون جاری کشور پیروی می‌کند.
          <br /> اگر می‌خواهید از خدمات و قابلیت‌های غیررایگان پلتفرم بادی‌بان
          استفاده کنید، لازم است ابتدا هزینه تعیین‌شده را بپردازید. تمامی
          هزینه‌های درج‌شده در پلتفرم به‌روز هستند.
          <br /> اعتبارهای هدیه پلتفرم بادی‌بان فقط برای استفاده از خدمات
          بادی‌بان است و قابل تبدیل به وجه نیست و کاربران اجازه خرید و فروش
          کد‌های اعتباری یا تخفیف پلتفرم بادی‌بان یا انتقال آن به اشخاص دیگر به
          هر نحوی را ندارند.
        </p>
      </div>

      <div>
        <h2 className="font-bold text-lg mb-2 mt-10">حساب کاربری </h2>

        <p className="text-justify leading-7">
          برای استفاده از تمامی خدمات پلتفرم تفسیر آزمایش بادی‌بان، لازم است که
          یک حساب کاربری ایجاد کنید و سن شما بالای ۱۸ سال باشد. ایجاد حساب با
          ثبت شماره تلفن همراه انجام می‌شود.
          <br /> برای استفاده از خدمات بادی‌بان، کاربران می‌بایست نام، نام
          خانوادگی، سن و جنسیت را به همراه عکس یا پی‌دی‌اف جواب آزمایش وارد
          کنند. وارد کردن این فیلدها برای دریافت نتایج شخصی‌سازی‌شده و ثبت
          پیشینه نتایج در پروفایل کاربری اشخاص الزامی است.
          <br /> در صورت فعالسازی گزینه تفسیر آزمایش برای دیگری، کاربر می‌بایست
          برای دریافت پاسخ دقیق از مدل هوش مصنوعی، نام، نام خانوادگی، سن و جنسیت
          آزمایش‌دهنده را وارد نماید. همچنین در صورت تمایل، کاربران می‌توانند
          اطلاعات شخصی دیگری از جمله ایمیل یا کد ملی خود را وارد کنند تا تجربه
          بهتری از کار با پلتفرم داشته باشند. مسئولیت تمامی فعالیت‌های انجام‌شده
          از حساب کاربری با صاحب حساب است، لذا رعایت نکات امنیتی ضروری است.
        </p>
      </div>

      <div>
        <h2 className="font-bold text-lg mb-2 mt-10">
          <br /> حریم خصوصی
        </h2>

        <p className="text-justify leading-7">
          سیاست‌های حفظ حریم خصوصی بادی‌بان، نحوه جمع‌آوری و استفاده از اطلاعات
          کاربران را مشخص می‌کند و بخشی از شرایط استفاده از خدمات بادی‌بان است.
          این سند شامل اطلاعات دقیق‌تر در رابطه با حریم خصوصی است.
        </p>
      </div>

      <div>
        <h2 className="font-bold text-lg mb-2 mt-10">مالکیت محتوا </h2>

        <p className="text-justify leading-7">
          تمامی محتوای وب‌سایت و پلتفرم بادی‌بان شامل متون، طرح‌ها، رابط کاربری
          و بصری، تصاویر، علائم تجاری و در مجموع «محتوا» به بادی‌بان تعلق دارد و
          کاربران تنها با رضایت صاحبان پلتفرم یا طبق قانون مجاز به استفاده از
          آنها هستند. محتوای منتشرشده توسط کاربران نیز متعلق به آنها است و
          مسئولیت حقوقی با خود آنان است.
        </p>
      </div>

      <div>
        <h2 className="font-bold text-lg mb-2 mt-10">ارسال نظرات </h2>

        <p className="text-justify leading-7">
          کاربران می‌توانند نظر خود را در پلتفرم و وب‌سایت بادی‌بان ثبت کنند؛
          اما نظرات باید مطابق با قوانین سایت و پلتفرم بوده و از درج هرگونه
          محتوای نامناسب یا تبلیغاتی پرهیز کنند. نظراتی شامل موارد زیر تایید
          نخواهند شد:
        </p>

        <ul className="my-5 list-inside list-disc">
          <li className="my-2 text-justify"> استفاده از الفاظ رکیک </li>
          <li className="my-2 text-justify"> محتوای متناقض عرف جامعه </li>
          <li className="my-2 text-justify">
            توهین به اشخاص، مقدسات و قومیت‌ها
          </li>
          <li className="my-2 text-justify"> هرگونه تبلیغات </li>
          <li className="my-2 text-justify"> درج لینک و آدرس سایت‌های دیگر </li>
          <li className="my-2 text-justify">
            درج شماره تلفن، ایمیل و اطلاعات تماس به عنوان نظر
          </li>
          <li className="my-2 text-justify">
            درج نام کاربری افراد در سایت‌های مختلف مانند آی‌دی اینستاگرام و
            تلگرام و …
          </li>
          <li className="my-2 text-justify"> درخواست و دعوت به چت </li>
          <li className="my-2 text-justify"> درج نظرات غیر‌مرتبط با برنامه </li>
        </ul>
      </div>

      <div>
        <h2 className="font-bold text-lg mb-2 mt-10">
          پایان استفاده از بادی‌بان{" "}
        </h2>

        <p className="text-justify leading-7">
          ما در بادی‌بان پیوسته در حال تلاش برای بهبود خدمات و قابلیت‌های
          ارائه‌شده به کاربران هستیم؛ از این رو ممکن است ویژگی‌های جدیدی اضافه
          یا حذف کنیم، محدودیت‌های جدیدی را اعمال کرده یا کاهش دهیم یا برخی از
          قابلیت‌ها را به تعلیق درآوریم. تلاش ما همواره برای جلب رضایت کاربران
          است؛ اما تصمیم به ادامه استفاده از پلتفرم بادی‌بان با شماست. در صورت
          تصمیم به پایان‌دادن استفاده از بادی‌بان می‌توانید با ما تماس بگیرید تا
          حساب کاربری شما مسدود شود؛ ولی برخی اطلاعات نظیر تراکنش‌های مالی به
          دلایل قانونی حفظ خواهند شد.
        </p>
      </div>

      <div>
        <h2 className="font-bold text-lg mb-2 mt-10">
          مسئولیت‌ها و قوانین تخلف
        </h2>

        <p className="text-justify leading-7">
          هرگونه استفاده غیرمجاز، اختلال در خدمات و قابلیت‌های پلتفرم یا تلاش
          برای دسترسی غیرمجاز به اطلاعات و سرویس‌های بادی‌بان ممنوع است. پلتفرم
          بادی‌بان، در صورت مشاهده چنین فعالیت‌هایی، حق پیگیری قانونی را برای
          خود محفوظ می‌دارد و در صورت لزوم، حساب کاربر را مسدود خواهد کرد.
        </p>
      </div>

      <div>
        <h2 className="font-bold text-lg mb-2 mt-10">
          تغییرات در شرایط استفاده
        </h2>

        <p className="text-justify leading-7">
          ممکن است با تغییر در رویه‌ها و سیاست‌های پلتفرم بادی‌بان، شرایط
          استفاده به‌روزرسانی شود. در صورت اعمال تغییرات مهم، از طریق حساب
          کاربری به کاربران اطلاع داده خواهد شد.
        </p>
      </div>

      <div>
        <h2 className="font-bold text-lg mb-2 mt-10">ارتباط و ارائه بازخورد</h2>

        <p className="text-justify leading-7">
          پیشنهادات و انتقادات خود را از طریق ایمیل زیر به ما اطلاع دهید. تیم ما
          آماده پاسخگویی به شما خواهد بود و از بازخوردهای سازنده شما برای بهبود
          خدمات استفاده می‌کند.
        </p>
      </div>

      <div className="flex items-center justify-between my-16 border-t-2 pt-2">
        <p>تاریخ آخرین به‌روزرسانی: مهر ماه ۱۴۰۳</p>
        <a href="mailto:support@bodybon.info" className="text-pr_primary">
          <strong> support@bodybon.info </strong>
        </a>
      </div>
    </div>
  );
};

export default Terms;
